<div class="page-title-area page-title-four">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="page-title-item">
                <h2>{{'MENU.BlogDetails' | translate}}</h2>
                <ul>
                    <li><a routerLink="/">{{'MENU.HOME' | translate}}</a></li>
                    <li><i class="icofont-simple-right"></i></li>
                    <li>{{'MENU.BlogDetails' | translate}}</li>
                </ul>
            </div>
        </div>
    </div>
</div>
<div  style="padding: 15px;" *ngIf="id == '5c3e8e14-a6ba-434a-a5b1-935b4d08dbc7'">
  <div class="row text-center" style="margin: 30px">
      <h3>{{ language == 'en'? 'What is asthma?' : 'ما هو الربو؟'}}</h3>
  </div>
  <div class="row" style="margin: 30px 30px;display: flex;justify-content: center;align-items: center;text-align: justify;">
    <div class="col-lg-8" *ngIf="language =='en'">
     <p >Asthma is a condition that can make it hard to breathe. Asthma symptoms can be mild or severe. They can come and go. An asthma "attack" is when symptoms start suddenly. This happens when the airways in the lungs become more narrow and inflamed.
      Asthma can run in families.</p>
      <h5>What are the symptoms of asthma?</h5>
      <label>Asthma symptoms can include:</label>
      <ul>
        <li>Wheezing or noisy breathing</li>
        <li>Coughing</li>
        <li>Tight feeling in the chest</li>
        <li>Tight feeling in the chest</li>
      </ul>
      <label>Symptoms can happen each day, each week, or less often. Symptoms can range from mild to severe. Although it is rare, an asthma attack can sometimes even lead to death.</label>
      <h5>Is there a test for asthma?</h5>
      <label>Yes. Your doctor will ask you about your symptoms and have you do a breathing test to check how your lungs are working.
        If your doctor thinks that allergies might be making your asthma worse, they might suggest allergy testing. This can include skin tests or blood tests.
        </label>
        <h5>How is asthma treated?</h5>
        <label>Asthma is treated with different types of medicines. The medicines can be inhalers, liquids, or pills. Your doctor will prescribe medicine based on how often you have symptoms and how serious your symptoms are. There are 2 main types of asthma medicines:</label>
        <ul>
          <li>Quick-relief medicines stop symptoms quickly, in 5 to 15 minutes. Almost everyone with asthma carries a quick-relief inhaler with them. People use these medicines whenever they have asthma symptoms. Most people need these medicines 1 or 2 times a week, or less often. But when asthma symptoms get worse, more doses might be needed.</li>
          <li>Long-term controller medicines control asthma and help prevent future attacks. People who get asthma symptoms more than 2 times a week should use a controller medicine every day.</li>
        </ul>
        <label>
          Some medicines can work as both a controller medicine and a quick-relief medicine. These are taken once or twice a day as controller medicines. They can also be used for quick relief.
        </label>
        <label>
          It is very important to take all of the medicines the doctor prescribes, exactly how you are supposed to take them. You might have to take medicines a few times a day. Your doctor, nurse, or pharmacist will show you the right way to use your inhaler(s).
        </label>
        <label>If your symptoms get much worse all of a sudden, use your quick-relief medicine and contact your doctor or nurse. You might need to go to the hospital for treatment.</label>
    </div>
    <div class="col-lg-8" *ngIf="language =='ar'">
      <p >الربو هو حالة قد تسبب صعوبة التنفس. قد تكون أعراض الربو خفيفة أو شديدة. وقد تأتي وتختفي. تحدث "نوبة" الربو عندما تبدأ الأعراض فجأة. ويحدث ذلك عندما تصبح المجاري الهوائية في الرئتين أكثر ضيقًا والتهابًا.
        وقد يسري الربو في العائلات
        </p>
       <h5>ما هي أعراض الربو؟</h5>
       <label>قد تشمل أعراض الربو ما يلي: </label>
       <ul>
         <li>الأزيز أو الصوت المرتفع أثناء التنفس</li>
         <li>السعال</li>
         <li>الشعور بضيق في الصدر</li>
         <li>ضيق التنفس</li>
       </ul>
       <label>قد تحدث الأعراض كل يوم، أو كل أسبوع، أو بمعدل أقل من ذلك. وقد تتراوح الأعراض من خفيفة إلى شديدة. على الرغم من ندرة حدوث نوبة الربو، إلا أنها قد تؤدي أحيانًا إلى الوفاة</label>
       <h5>هل يوجد اختبار للربو؟</h5>
       <label>نعم. سيسألك طبيبك عن الأعراض التي تعاني منها وسيُخضِعك لاختبار تنفس لفحص الكفاءة التي تعمل بها رئتاك.
        إذا أعتقد طبيبك أن الحساسية قد تؤدي إلى تفاقم حالة الربو لديك، فقد يقترح إجراء اختبار الحساسية. وقد يشمل ذلك اختبارات الجلد أو اختبارات الدم
        
         </label>
         <h5>كيف يتم علاج الربو؟</h5>
         <label>يتم علاج الربو بأنواع مختلفة من الأدوية. وقد تكون الأدوية عبارة عن أجهزة استنشاق، أو سوائل، أو أقراص. سيصف طبيبك الدواء بناءً على عدد مرات ظهور الأعراض ومدى خطورتها. هناك نوعان رئيسيان من أدوية الربو</label>
         <ul>
           <li>أدوية المعالجة السريعة توقف الأعراض بسرعة خلال فترة تتراوح من 5 إلى 15 دقيقة. إن كل شخص مصاب بالربو تقريبًا يحمل معه جهاز استنشاقٍ للمعالجة السريعة. ويستخدم الأشخاص هذه الأدوية كلما ظهرت عليهم أعراض الربو. ويحتاج معظم الأشخاص إلى هذه الأدوية مرة أو مرتين في الأسبوع، أو بمعدل أقل. ولكن عندما تسوء أعراض الربو، قد تكون هناك حاجة إلى مزيد من الجرعات.</li>
           <li>أدوية التحكم طويلة الأمد تقوم بالتحكم في الربو وتساعد في الوقاية من النوبات المستقبلية. يجب على الأشخاص الذين يصابون بأعراض الربو أكثر من مرتين في الأسبوع استخدام دواء للتحكم في الربو كل يوم.</li>
         </ul>
         <label>
          يمكن لبعض الأدوية أن تعمل كدواء للتحكم و دواء معالجة سريعة. يتم تناول هذه الأدوية مرة أو مرتين يوميًا كأدوية تحكم. ويمكن استخدامها أيضًا للمعالجة السريعة.
         </label>
         <label>
          من المهم جدًا تناول جميع الأدوية التي يصفها الطبيب، تمامًا بالطريقة التي يُفتَرض بك أن تتناولها. وقد تضطر إلى تناول الأدوية بضع مرات في اليوم. سيوضح لك طبيبك أو ممرضك أو الصيدلي الطريقة الصحيحة لاستخدام جهاز (أجهزة) الاستنشاق.
         </label>
         <label>وإذا ساءت الأعراض بشكل مفاجئ، فاستخدم دواء المعالجة السريعة واتصل بطبيبك أو ممرضك. وقد تحتاج إلى الذهاب إلى المستشفى لتلقي العلاج.</label>
     </div>
    <div class="col-lg-4 blog-item" style="margin-top: -650px;">
      
        <a><img src="assets/img/blog.png" alt="Blog"  height="250px" width="350px"></a>
    
    </div>
  </div>
</div>
<div class="text-center" style="padding: 15px;" *ngIf="id != '5c3e8e14-a6ba-434a-a5b1-935b4d08dbc7'">
    <div style="margin: 30px">
        <h3>{{language =='en' ? Blog?.blogHeaderEn: Blog?.blogHeaderAr}}</h3>
      </div>
    <div class="row">
      <div class="col-lg-8" >
        <p style="margin: 30px 30px;display: flex;justify-content: center;align-items: center;text-align: justify;">{{language =='en' ? Blog?.blogDetailsEn : Blog?.blogDetailsAr}}</p>
      </div>
      <div class="col-lg-4 blog-item">
        <div class="blog-top">
          <a *ngIf="Blog?.image != null;else Blogimage"><img [src]="Blog?.image | SafeUrlPipe" alt="Blog" > </a>
          <ng-template #Blogimage><a><img src="assets/img/DefaultImage.png" alt="Blog"  height="250px" width="350px"></a></ng-template>
      </div>
      </div>
    </div>
  </div>
  
  